import React, { useState, useRef, useEffect } from 'react';
import { Printer, Download, ArrowLeft, Edit3, Eye, Loader2, AlertCircle } from 'lucide-react';
import { useSearchParams } from 'react-router-dom';


const GRNReportDesign = () => {
  const printRef = useRef();
  const [isPreviewMode, setIsPreviewMode] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // You can get grnId from props, URL params, or other sources
   // Replace this with actual GRN ID
   const [searchParams] = useSearchParams();
  const id = searchParams.get("grnid"); 

  console.log("grnid:",id);
  const [reportData, setReportData] = useState({
    company: {
      name: "Nissi Infotech",
      subtitle: "Nissi",
      type: "CIVIL CONSTRUCTION",
      address: "3/42-12, Nagappa colony, Kavundampalayam-636030, Tamil Nadu, India",
      phone: "Phone No: 9003744644",
      email: "infraconsoft-implementation@nissiinfotech.com"
    },
    supplier: {
      name: "",
      address: ""
    },
    details: {
      purReqNo: "-",
      purReqDate: "-",
      branch: "HEAD-OFFICE",
      quotationNo: "-",
      quotationDate: "-",
      supplierCode: "",
      poNo: "",
      poDate: "",
      classification: "C",
      invoiceNo: "",
      invoiceDate: "",
      grnNo: "",
      grnConfDate: "",
      deliveryType: ""
    },
    items: [],
    totals: {
      subTotal: 0.00,
      cgst: 0.00,
      freight: 0.00,
      other: 0.00,
      discount: 0.00,
      sgst: 0.00,
      packing: 0.00,
      roundOff: 0.00,
      afterDiscount: 0.00,
      igst: 0.00,
      insurance: 0.00,
      tcs: 0.00,
      totalAmount: 0.00
    },
    signatures: {
      inspectedBy: "",
      confirmedBy: "",
      billPassBy: "",
      authorizedBy: ""
    }
  });

  // API call function
  const fetchGRNData = async (grnId) => {
  setLoading(true);
  setError(null);

  try {
    const apiUrl = `http://nissi-india.com/api/grn_reportPrint/${grnId}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
    const data = await response.json();
    console.log("Fetched data:", data);

    if (!data.success || !Array.isArray(data.data)) {
      throw new Error("Invalid API response");
    }

    const first = data.data[0] || {};

    // transform supplier + details
    const transformedData = {
      ...reportData,
      supplier: {
        name: first.fld_suppliername || "",
        address: first.fld_Address1 || ""
      },
      details: {
        purReqNo: first.fld_PurchaseRequestNo || "-",
        purReqDate: first.PurReqDate || "-",
        branch: first.fld_branchname || "HEAD-OFFICE",
        quotationNo: first.fld_quotationno || "-",
        quotationDate: first.fld_quotationdate || "-",
        supplierCode: first.fld_suppliercode || "",
        poNo: first.fld_POno || "",
        poDate: first.PurDate || "",
        classification: first.grade || "C",
        invoiceNo: first.fld_Invno || "",
        invoiceDate: first.fld_InvDate || "",
        grnNo: first.fld_grnno || "",
        grnConfDate: first.GRNdate || "",
        deliveryType: first.deliveryType || ""
      },
      items: data.data.map((item, index) => ({
        sno: index + 1,
        itemCode: item.fld_itemcode || "",
        description: item.fld_itemname || "",
        hsnNo: item.fld_itemPartNo || "",
        units: item.fld_uomname || "",
        reqQty: parseFloat(item.fld_poqty) || 0,
        revQty: parseFloat(item.fld_rejqty) || 0,
        accQty: parseFloat(item.fld_acceptedqty) || 0,
        rate: parseFloat(item.fld_poprice) || 0,
        discount: 0, // not in API
        cgst: 0,     // not in API
        sgst: 0,     // not in API
        igst: 0,     // not in API
        amount: (parseFloat(item.fld_acceptedqty) || 0) * (parseFloat(item.fld_poprice) || 0)
      })),
      totals: {
        subTotal: data.data.reduce(
          (sum, item) => sum + ((parseFloat(item.fld_acceptedqty) || 0) * (parseFloat(item.fld_poprice) || 0)),
          0
        ),
        cgst: 0,
        sgst: 0,
        igst: 0,
        freight: 0,
        other: 0,
        discount: 0,
        packing: 0,
        roundOff: 0,
        afterDiscount: 0,
        insurance: 0,
        tcs: 0,
        totalAmount: data.data.reduce(
          (sum, item) => sum + ((parseFloat(item.fld_acceptedqty) || 0) * (parseFloat(item.fld_poprice) || 0)),
          0
        )
      },
      signatures: {
        inspectedBy: "",
        confirmedBy: "",
        billPassBy: "",
        authorizedBy: ""
      }
    };

    setReportData(transformedData);
  } catch (err) {
    console.error("Error fetching GRN data:", err);
    setError(`Failed to fetch GRN data: ${err.message}`);
  } finally {
    setLoading(false);
  }
};


  // Fetch data on component mount or when grnId changes
  useEffect(() => {
    if (id) {
      fetchGRNData(id);
    }
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    console.log("Download PDF functionality");
  };

  const handleRetry = () => {
    if (id) {
      fetchGRNData(id);
    }
  };

  const updateField = (section, field, value) => {
    setReportData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [field]: value
      }
    }));
  };

  // Loading state
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <Loader2 className="h-8 w-8 animate-spin mx-auto mb-4 text-blue-600" />
          <p className="text-gray-600">Loading GRN Report...</p>
        </div>
      </div>
    );
  }

  // Error state
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full mx-4">
          <div className="flex items-center mb-4 text-red-600">
            <AlertCircle className="h-6 w-6 mr-2" />
            <h2 className="text-lg font-semibold">Error Loading Report</h2>
          </div>
          <p className="text-gray-600 mb-4">{error}</p>
          <div className="flex gap-3">
            <button
              onClick={handleRetry}
              className="flex-1 bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition-colors"
            >
              Retry
            </button>
            <button
              onClick={() => setError(null)}
              className="flex-1 bg-gray-300 text-gray-700 px-4 py-2 rounded hover:bg-gray-400 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 print:bg-white">
      {/* Header Controls - Hidden in print */}
      <div className="print:hidden bg-white shadow-sm border-b p-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex items-center justify-between">
            <button className="flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors">
              <ArrowLeft size={18} />
              Back
            </button>
            <div className="flex items-center gap-3">
              <button
                onClick={() => setIsPreviewMode(!isPreviewMode)}
                className="flex items-center gap-2 px-4 py-2 text-blue-600 hover:bg-blue-50 border border-blue-200 rounded-lg text-sm transition-colors"
              >
                {isPreviewMode ? <Edit3 size={16} /> : <Eye size={16} />}
                {isPreviewMode ? 'Edit Mode' : 'Preview Mode'}
              </button>
              <button
                onClick={handleRetry}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white hover:bg-blue-700 rounded-lg text-sm transition-colors"
              >
                <Loader2 size={16} />
                Refresh Data
              </button>
              <button
                onClick={handleDownload}
                className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white hover:bg-green-700 rounded-lg text-sm transition-colors"
              >
                <Download size={16} />
                Export PDF
              </button>
              <button
                onClick={handlePrint}
                className="flex items-center gap-2 px-4 py-2 bg-gray-900 text-white hover:bg-black rounded-lg text-sm transition-colors"
              >
                <Printer size={16} />
                Print Report
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Main Report Content */}
      <div className="max-w-5xl mx-auto print:max-w-full print:mx-0 p-6 print:p-0">
        <div
          ref={printRef}
          className="bg-white print:bg-white shadow-lg print:shadow-none border print:border-2 print:border-black rounded-lg print:rounded-none overflow-hidden"
        >
          {/* Report Header */}
          <div className="bg-black text-white print:bg-black print:text-white p-2 text-center">
            <h1 className="text-lg font-bold">Main Report</h1>
          </div>

          {/* Company Header */}
          <div className="border-b-2 border-black print:border-b-2 print:border-black">
            <div className="flex">
              {/* Logo Section */}
              <div className="w-32 border-r-2 border-black print:border-r-2 print:border-black flex items-center justify-center p-4">
                <div className="w-20 h-20 bg-black text-white flex items-center justify-center rounded">
                  <div className="text-center">
                    <div className="text-xs font-bold">NISSI</div>
                    <div className="text-xs">INFOTECH</div>
                    <div className="text-xs">PVT LTD</div>
                  </div>
                </div>
              </div>
              
              {/* Company Info */}
              <div className="flex-1 p-4 text-center">
                <h1 className="text-xl font-bold text-black">{reportData.company.name}</h1>
                <p className="text-sm font-semibold text-gray-700">{reportData.company.subtitle}</p>
                <p className="text-sm font-medium text-gray-600 uppercase">{reportData.company.type}</p>
                <p className="text-xs text-gray-600 mt-1">{reportData.company.address}</p>
                <p className="text-xs text-gray-600">{reportData.company.phone}</p>
                <p className="text-xs text-gray-600">{reportData.company.email}</p>
              </div>
            </div>
          </div>

          {/* Report Title */}
          <div className="bg-gray-100 print:bg-gray-100 border-b-2 border-black print:border-b-2 print:border-black p-3 text-center">
            <h2 className="text-lg font-bold text-black">GOODS RECEIVED NOTE REPORT</h2>
          </div>

          {/* Supplier and Details Section */}
          <div className="flex border-b-2 border-black print:border-b-2 print:border-black">
            {/* Supplier Info */}
            <div className="w-1/3 border-r-2 border-black print:border-r-2 print:border-black p-4">
              <div className="bg-gray-50 print:bg-gray-50 p-3 rounded print:rounded-none">
                <h3 className="text-sm font-bold text-black mb-3">Supplier Information</h3>
                <div className="space-y-2 text-sm">
                  <div>
                    <span className="font-semibold text-gray-700">Name:</span>
                    <p className="text-black">{reportData.supplier.name || "Loading..."}</p>
                  </div>
                  <div>
                    <span className="font-semibold text-gray-700">Address:</span>
                    <p className="text-black">{reportData.supplier.address || "Loading..."}</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Order Details */}
            <div className="flex-1 p-4">
              <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-sm">
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">PurReq No:</span>
                  <span className="text-black">{reportData.details.purReqNo}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">PurReq Date:</span>
                  <span className="text-black">{reportData.details.purReqDate}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Branch:</span>
                  <span className="text-black">{reportData.details.branch}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Quotation No:</span>
                  <span className="text-black">{reportData.details.quotationNo}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Quotation Date:</span>
                  <span className="text-black">{reportData.details.quotationDate}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Supplier Code:</span>
                  <span className="text-black text-xs">{reportData.details.supplierCode}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">PO No:</span>
                  <span className="text-black">{reportData.details.poNo}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">PO Date:</span>
                  <span className="text-black">{reportData.details.poDate}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Classification:</span>
                  <span className="text-black">{reportData.details.classification}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Invoice No:</span>
                  <span className="text-black">{reportData.details.invoiceNo}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">Invoice Date:</span>
                  <span className="text-black">{reportData.details.invoiceDate}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">GRN No:</span>
                  <span className="text-black">{reportData.details.grnNo}</span>
                </div>
                <div className="flex justify-between border-b border-gray-300 pb-1">
                  <span className="font-semibold text-gray-700">GRNConf.Date:</span>
                  <span className="text-black">{reportData.details.grnConfDate}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-semibold text-gray-700">DeliveryType:</span>
                  <span className="text-black">{reportData.details.deliveryType}</span>
                </div>
              </div>
            </div>
          </div>

          {/* Items Table */}
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-xs">
              <thead>
                <tr className="bg-black text-white print:bg-black print:text-white">
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">S.No</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-left">Item code</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-left">Description</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">HSN No</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Units</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Req.Qty</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Rev.Qty</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Acc.Qty</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Rate</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Dis%</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">CGST%</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">SGST%</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">IGST%</th>
                  <th className="border border-gray-400 print:border-black px-2 py-2 text-center">Amount</th>
                </tr>
              </thead>
              <tbody>
                {reportData.items.length > 0 ? (
                  reportData.items.map((item, index) => (
                    <tr key={index} className="hover:bg-gray-50 print:hover:bg-transparent">
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.sno}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2">{item.itemCode}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 font-medium">{item.description}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.hsnNo}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.units}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.reqQty.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center font-semibold">{item.revQty.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center font-semibold">{item.accQty.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">₹{item.rate.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.discount.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.cgst.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.sgst.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center">{item.igst.toFixed(2)}</td>
                      <td className="border border-gray-300 print:border-black px-2 py-2 text-center font-bold">₹{item.amount.toFixed(2)}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="14" className="border border-gray-300 print:border-black px-2 py-8 text-center text-gray-500">
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Rest of the component remains the same... */}
          {/* Totals Section */}
          <div className="border-t-2 border-black print:border-t-2 print:border-black p-4">
            <div className="bg-gray-50 print:bg-gray-50 p-4 rounded print:rounded-none">
              <div className="grid grid-cols-4 gap-4 text-sm">
                <div className="space-y-2">
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Sub Total:</span>
                    <span className="font-bold">₹{reportData.totals.subTotal.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Discount:</span>
                    <span>₹{reportData.totals.discount.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">A.Dis Total:</span>
                    <span>₹{reportData.totals.afterDiscount.toFixed(2)}</span>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">CGST:</span>
                    <span>₹{reportData.totals.cgst.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">SGST:</span>
                    <span>₹{reportData.totals.sgst.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">IGST:</span>
                    <span>₹{reportData.totals.igst.toFixed(2)}</span>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Freight Charges:</span>
                    <span>₹{reportData.totals.freight.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Packing & Forward:</span>
                    <span>₹{reportData.totals.packing.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="font-semibold">Insurance:</span>
                    <span>₹{reportData.totals.insurance.toFixed(2)}</span>
                  </div>
                </div>
                
                <div className="space-y-2">
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Other Charges:</span>
                    <span>₹{reportData.totals.other.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between border-b border-gray-300 pb-1">
                    <span className="font-semibold">Round Off:</span>
                    <span>₹{reportData.totals.roundOff.toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between border-t-2 border-black pt-2">
                    <span className="font-bold text-lg">Total Amount:</span>
                    <span className="font-bold text-lg">₹{reportData.totals.totalAmount.toFixed(2)}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Signature Section */}
          <div className="border-t-2 border-black print:border-t-2 print:border-black p-4">
            <div className="grid grid-cols-4 gap-6 text-center">
              <div className="border border-gray-300 print:border-black p-4 rounded print:rounded-none min-h-24">
                <h4 className="font-bold text-sm mb-2">Inspected By</h4>
                <div className="mt-8 text-xs whitespace-pre-line font-medium">
                  {reportData.signatures.inspectedBy}
                </div>
              </div>
              
              <div className="border border-gray-300 print:border-black p-4 rounded print:rounded-none min-h-24">
                <h4 className="font-bold text-sm mb-2">Confirmed By</h4>
                <div className="mt-8 text-xs font-medium">
                  {reportData.signatures.confirmedBy}
                </div>
              </div>
              
              <div className="border border-gray-300 print:border-black p-4 rounded print:rounded-none min-h-24">
                <h4 className="font-bold text-sm mb-2">Bill Pass By</h4>
                <div className="mt-8 text-xs">
                  {reportData.signatures.billPassBy || ""}
                </div>
              </div>
              
              <div className="border border-gray-300 print:border-black p-4 rounded print:rounded-none min-h-24">
                <h4 className="font-bold text-sm mb-2">Authorized By</h4>
                <div className="mt-8 text-xs font-medium">
                  {reportData.signatures.authorizedBy}
                </div>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="border-t-2 border-black print:border-t-2 print:border-black bg-gray-100 print:bg-gray-100 p-3">
            <div className="flex justify-between items-center text-xs">
              <div>
                <p className="font-medium">Report generated by ERP-Software - www.infraconsoft.com owned by www.nissiinfotech.com</p>
              </div>
              <div>
                <p className="font-bold">Page 1 of 1</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Print Styles */}
      <style jsx>{`
        @media print {
          @page {
            margin: 0.5in;
            size: A4;
          }
          
          .print\\:hidden {
            display: none !important;
          }
          
          body {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          * {
            -webkit-print-color-adjust: exact;
            color-adjust: exact;
          }
          
          .shadow-lg {
            box-shadow: none !important;
          }
        }
      `}</style>
    </div>
  );
};

export default GRNReportDesign;